/**
 * Executive client–scoped HTTP APIs from OpenAPI live under
 * `/api/v2/clients/{person_uuid}/…` (for example people search, settings, team).
 *
 * On `/users/$userId` routes, that `$userId` is the client’s `person_uuid` for these calls.
 *
 * Candidate detail uses `getExecutiveClientCandidateOptions` from `client/@tanstack/react-query.gen`
 * (`GET /api/v2/clients/{person_uuid}/candidates/{candidate_uuid}`).
 *
 * Trending list/detail uses helpers in `executiveClientTrending.ts`
 * (`GET /api/v2/clients/{person_uuid}/trending/…`) until OpenAPI exports match.
 */
export function executiveClientPathParams(personUuid: string) {
  return { person_uuid: personUuid };
}
